import './compo.css';

export type Ctx = {
    obj: any, 
    element: string, 
    path: string, 
    prop: string, 
    value: any, 
    _id: any,
    list: any[] // Added list to the Ctx type
}

export class Store {
    
    private static _id:number=10000;

    static get_id() { this._id++; return this._id.toString()}

    static debounce(func: (cb: any, ctx: Ctx) => void, wait: number) {
        let timeout: any;
        return function(this: any, cb:any, ctx: Ctx) {
            const context = this;
            const later = function() {
                timeout = null;
                func.call(context, cb, ctx);
            };
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
        };
    }

    static getHandlers(classRef: any) {
        const staticMethods = Object.getOwnPropertyNames(classRef);
        console.log(staticMethods)
        const handlers: any = {}
        for (const method_name of staticMethods) {
            if (method_name.indexOf('Handler') > -1) {
                if (classRef && typeof classRef[method_name] === 'function') {
                    handlers[method_name] = classRef[method_name];
                }
            }
        }
        return handlers;
    }

}



export function cc_button(ctx:Ctx, handler:string, classname:string, title:string):string {
    const title_=title?title:''
    return `<button ${Compo.ctx(ctx, handler, '', classname) } >  ${title_} </button>`
}

export function cc_input(ctx:Ctx, handler:string, prop: string, classname:string, title:string, value:any):string {
    const label_=title?`<label>${title}</label>`:''
    const value_=value?value:''
    return  `${label_}<input ${Compo.ctx(ctx, handler, prop, classname)}  type="text"  value="${value_}"/>`
}


export function cc_select(options: string[], ctx: Ctx, handler: string, prop:string, classname: string, title: string): string {
    const optionsHTML = options.map(option => `<option value="${option}">${option}</option>`).join('');
    const title_ = title ? `<label>${title}</label>` : '';
    return `
        ${title_}
        <select ${Compo.ctx(ctx, handler, prop, classname)}>
            ${optionsHTML}
        </select>
    `;
}

export async function cc_list(ctx: Ctx, item_html_generator: Function): Promise<string> {
    let items:string=''
    for (const item of ctx.obj) {
        items+=await item_html_generator({ ...ctx, obj: item, path:`${ctx.path}{_id:${item._id}}`, _id: item._id, inject_html: '<span>Person </span>'});
    }

    const s= `<div class="${ctx.path}-list">
    ${items}
    </div>`;

    return s;
}

export class Compo {

    static async render(ctx:Ctx, html: Function) {
        const el = document.getElementById(ctx.element);
        el!.innerHTML = await html(ctx);
        
    }


    static ctx(ctx:Ctx, handler:string, prop:string, classname:string) {
        const classname_=classname?`class="${classname}"`:''
        const path_= ctx.path?`"path":"${ctx.path}",`:''
        const prop_= prop?`"prop":"${prop}",`:''
        const _id_ = ctx._id?`"_id":"${ctx._id}",`:''
        const handler_ = handler ?`"handler":"${handler}"`:''
        const s=`
            ${classname_} data-comp='{  ${path_} ${prop_} ${_id_} ${handler_}  }'
            `
        return s
    }

   

    static async addObjectToListOK(ctx: Ctx) {


        const parents = document.getElementsByClassName(`${ctx.path}`)
        for (const parent of parents) {
            const listHTML = parent
            if (listHTML) {
                const wrapper = document.createElement('span');
                wrapper.innerHTML = await CompoPerson.html({...ctx, path:`${ctx.path}{_id:${ctx.obj._id}}`, _id:ctx.obj._id});
                listHTML.appendChild(wrapper);
            }
        }
    }


    static deleteObjectFromListOK(ctx:Ctx) {

        const selector =`${ctx.path}{_id:${ctx._id}}`
        const elements = document.getElementsByClassName(selector)
        for (const el of elements) {
             (<any>el).style.display="none"; 
        }
    }


    
    static changeObjectValueOK(ctx: Ctx) {

        console.log('changeObjectValueOK (prop, value): (', ctx.prop, ctx.value,')')

        const elements = document.querySelectorAll(`[data-comp*="${ctx.path}"]`);
        elements.forEach(element => {
            const el = (<any>element)
            const data = JSON.parse(el.dataset.comp);

            if (data.prop === ctx.prop) {
                if (element instanceof HTMLInputElement || element instanceof HTMLSelectElement || element instanceof HTMLTextAreaElement) {
                    element.value = ctx.value;
                } else {
                    element.textContent = `${ctx.value}`;
                }
            }
        });
    }



    static addInputHandlers(ctx: Ctx, handlers: any) {
        const parent = document.getElementById(ctx.path);
        if (!parent) { console.error("addInputHandlers; NO TOP LEVEL ELEMENT"); return; }
        parent.addEventListener('input', async (event) => {
            const target = event.target as HTMLInputElement;
            if (target.dataset && target.dataset.comp) {
                const data = JSON.parse(target.dataset.comp);
                const handlerName = data.handler;

                if (handlerName && handlers[handlerName] && typeof handlers[handlerName] === 'function') {
                    const value = (target as HTMLInputElement).value;
                    const ctx_new = { ...ctx, path: data.path, prop: data.prop, value: target.value}

                    
                    handlers[handlerName](ctx_new),1000;
                }
            }
        });
    }

    static addButtonHandlers(ctx: Ctx, handlers: any) {
        const parents = document.getElementsByClassName(ctx.path);
        for (const parent of parents) {
            if (!parent) { console.error("addButtonHandlers: NO TOP LEVEL ELEMENT"); return; }
            parent.addEventListener('click', async (event) => {
                const target = event.target as HTMLElement;
                if (target.dataset && target.dataset.comp) {
                    console.log(target.dataset.comp)
                    const data = JSON.parse(target.dataset.comp);
                    const handlerName = data.handler;

                    if (handlerName && handlers[handlerName] && typeof handlers[handlerName] === 'function') {
                        await handlers[handlerName]({ ...ctx, prop: data.prop, value: target.dataset.value || '', _id: data._id});
                    }
                }
            });
        }
    }

    
}


export class CompoPerson {

    static async init(_id:any) {
        return { ages:['10','11','12']}
    }

    static async html(ctx:Ctx): Promise<string> {

        console.log(ctx.obj)
        const params=await CompoPerson.init(ctx._id)
        const s: string = `
            <div class="cc-item ${ctx.path}">
               
                ${cc_button(ctx, 'delPersonHandler','cc-delete-button', 'Delete')}          
                ${cc_input(ctx,'nameChgHandler','name','','Name:',ctx.obj.name)}
                ${cc_input(ctx,'nameChgHandler','name','','Name:',ctx.obj.name)}
                <!-- ${cc_input(ctx,'ageChgHandler','age','','Age:',ctx.obj.age)} -->
                ${cc_select(params.ages,ctx,'selAgeHandler','age','cc-select-age','Age:')}

                
            </div>
        `;
        return s;
    }
}

export class CompoPersonList {

    static async html(ctx:Ctx): Promise<string> {

        const s: string = `
            <div class="cc-list ${ctx.path}" id="${ctx.path}">
                
                ${cc_button(ctx, 'chgFirstPersonHandler','cc-add-button', 'Change Person 1')}          
                ${cc_button(ctx, 'addPersonHandler','cc-add-button', 'Add person')}          
                ${await cc_list(ctx,CompoPerson.html )}

            </div>
        `;
        
        console.log(s);
        return s;
    }
}

